import { z } from 'zod';
export const ApiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
        requestId: z.string().optional(),
    }),
});
export const PageMetaSchema = z.object({
    nextCursor: z.string().nullable(),
});
export const wrap = (data) => z.object({ data, meta: z.record(z.unknown()).optional() });
export const wrapPaged = (item) => z.object({ data: z.array(item), meta: PageMetaSchema });
//# sourceMappingURL=responses.js.map